import { jsx as _jsx } from "react/jsx-runtime";
import { Children, useMemo } from "react";
import { Skeleton } from "../../../../../../structures/others/skeleton/index.js";
import Searcher from "../../../index.js";
import { SearcherItem } from "../../../styled.js";
import * as SS from "../../styled.js";
import * as S from "./styled.js";
export const SearcherSkeletonMobile = ({ config  })=>{
    const { top , variants =[]  } = config.mobile;
    const finalVariants = useMemo(()=>Array.isArray(variants) ? variants : new Array(variants).fill({
            variant: 'medium'
        }), [
        variants
    ]);
    return /*#__PURE__*/ _jsx(SS.SearcherSkeletonWrapper, {
        children: /*#__PURE__*/ _jsx(Searcher, {
            "data-testid": "SearcherSkeletonMobile",
            top: top && Children.toArray(Array.from({
                length: top.maxItems
            }).map(()=>/*#__PURE__*/ _jsx(S.SkeletonItemTop, {
                    variant: "text",
                    animation: "wave",
                    width: "150px",
                    height: "40px"
                }))),
            TopComponent: S.SearcherTop,
            MiddleComponent: S.SkeletonSearcherMiddle,
            children: Children.toArray(finalVariants.map(({ variant  })=>/*#__PURE__*/ _jsx(SearcherItem, {
                    $variant: variant,
                    children: /*#__PURE__*/ _jsx(Skeleton, {
                        variant: "rectangular",
                        animation: "wave",
                        width: "100%",
                        height: "56px"
                    })
                })))
        })
    });
};
export default SearcherSkeletonMobile;

//# sourceMappingURL=index.js.map